<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm/uniodontos">Uniodontos</router-link>
          </li>
          <li class="breadcrumb-item active">Criar uniodonto</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{erroMensagem}}</span>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações da Uniodonto
            </h2>
          </div>
          <div class="row">
            <div class="col-md-8">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Nome uniodonto</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o nome da uniodonto"
                      v-model="operadora.name"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>CNPJ</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o CNPJ"
                      v-model="operadora.cnpj"
                      v-mask="['##.###.###/####-##']"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Código ANS</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o código ANS"
                      v-model="operadora.ans"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Email notificação de vendas</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o e-mail que irá receber as notifcações de vendas"
                      v-model="operadora.email"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Mazepag ID</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o código Mazepag ID"
                      v-model="operadora.mazepag_id"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Mazepag Token</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o Mazepag token"
                      v-model="operadora.mazepag_token"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Logo uniodonto</label>
                <input
                  type="file"
                  class="form-control"
                  placeholder="Informe a foto"
                  @change="trocaFoto"
                />
              </div>
              <img :src="imagem_foto" class="img-thumbnail" />
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Telefone de Contato</label>
                <input
                  class="form-control"
                  v-model="operadora.telefone"
                  type="text"
                  placeholder="Telefone"
                  v-mask="['(##) #####-####','(##) ####-####']"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Usuário de acesso</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Login do usuário"
                  v-model="operadora.usuario"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Senha</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe a senha"
                  v-model="operadora.password"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Mostrar dados cartão</label>
                <select
                  class="form-control"
                  v-model="operadora.recorrencia"
                >
                  <option value='' selected disabled>Selecione</option>
                  <option value='0' >SIM</option>
                  <option value="1">NÃO</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>E-mail pagseguro</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o email vinculado ao pagseguro"
                  v-model="operadora.pagseguro_email"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Token Pagseguro</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o token"
                  v-model="operadora.pagseguro_token"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Token Acesso</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o token"
                  v-model="operadora.TokenAcesso"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Url de Integração</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe a url"
                  v-model="operadora.url_integracao"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Descrição Pós-Vendas</label>
                <vue-editor
                  v-model="operadora.texto_email_pos_venda"
                  :editorToolbar="customToolbar"
                  placeholder="Aqui você deve preencher com o conteúdo que deseja, que seja mostrado no e-mail de fechamento da compra. O mesmo texto será mostrado na página de fechamento do pedido"
                ></vue-editor>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12" v-if="erroCep">
              <div class="alert alert-danger alert-dismissible" role="alert">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div v-html="msgErroCep"></div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>CEP</label>
                <input
                  v-mask="'#####-###'"
                  type="text"
                  class="form-control"
                  placeholder="XXXXX-XXX"
                  v-model="endereco.cep"
                  @blur="procuraCep()"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Estado</label>
                <input type="text" class="form-control" readonly v-model="endereco.uf" placeholder="Estado" />
              </div>
            </div>
            <div class="col-md-7">
              <div class="form-group">
                <label>Cidade</label>
                <input type="text" class="form-control" readonly v-model="endereco.localidade" placeholder="Cidade" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label>Bairro</label>
                <input type="text" class="form-control" v-model="endereco.bairro" placeholder="Bairro" />
              </div>
            </div>
            <div class="col-md-7">
              <div class="form-group">
                <label>Logradouro</label>
                <input type="text" class="form-control" v-model="endereco.logradouro"  placeholder="Logradouro"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Número</label>
                <input type="text" class="form-control" v-model="endereco.numero" placeholder="Número" />
              </div>
            </div>
            <div class="col-md-9">
              <div class="form-group">
                <label>Complemento</label>
                <input type="text" class="form-control" v-model="endereco.complemento" placeholder="Complemento" />
              </div>
            </div>
          </div>
        </div>

        <hr />
        <p>
          <button href="#0" class="btn_1 medium pull-right" @click="cria_uniodonto">Criar Uniodonto</button>
        </p>

        <!-- /container-fluid-->
      </div>
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import moment from "moment";
import { VueEditor } from "vue2-editor";
import { Money } from "v-money";

export default {
  mixins: [funcoesGerais],
  components: {
    VueEditor,
    Money,
  },
  data() {
    return {
      imagem_foto: "",
      mostraErro: false,
      isLoading: false,
      erroCep: false,
      msgErroCep: "",
      endereco: {
        cep: "",
        uf: "",
        localidade: "",
        logradouro: "",
        bairro: "",
        numero: "",
        complemento: "",
      },
      operadora: {}
    };
  },
  methods: {
    procuraCep() {
      var self = this;
      if (self.endereco.cep.length == 9) {
        self.isLoading = true;
        self.erroCep = false;
        self.$http
          .get("https://viacep.com.br/ws/" + self.endereco.cep + "/json/")
          .then((res) => res.json())
          .then(
            (response) => {
              self.isLoading = false;
              self.endereco = [];
              if (response.erro) {
                self.msgErroCep =
                  "<strong>Cep incorreto!</strong> Verifique o cep informado.";
                self.erroCep = true;
              } else {
                self.endereco = response;
              }
            },
            (err) => {
              self.isLoading = false;
              self.endereco = [];
              self.msgErroCep =
                "<strong>Erro na consulta!</strong> Tente novamente.";
              self.erroCep = true;
            }
          );
      } else {
        self.msgErroCep =
          "<strong>Cep incorreto!</strong> Verifique o cep informado.";
        self.erroCep = true;
      }
    },

    emCentavos(valor) {
      return Math.round(valor * 100);
    },
    emReais(valor) {
      return valor / 100;
    },
    cria_uniodonto() {
      var self = this;
      self.operadora.end_cep = self.endereco.cep;
      self.operadora.end_estado = self.endereco.uf;
      self.operadora.end_cidade = self.endereco.localidade;
      self.operadora.end_logradouro = self.endereco.logradouro;
      self.operadora.end_bairro = self.endereco.bairro;
      self.operadora.end_numero = self.endereco.numero;
      self.operadora.end_complemento = self.endereco.complemento;

      var objRequest = new FormData();
      var item = self.operadora;
      for (var key in item) {
        if (item[key]) objRequest.append(key, item[key]);
      }

      self.isLoading = true;
      ajax("post", "/operadoras", objRequest)
        .then((response) => {
          self.isLoading = false;
            alerta(
               "success",
               "Criado",
               "Uniodonto criada com sucesso!"
             );
          self.$router.replace(
            self.$route.query.redirect || "/adm/uniodontos"
          );
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    trocaFoto: function ($event) {
      this.operadora.logo_src = $event.target.files[0];
      this.imagem_foto = URL.createObjectURL(this.operadora.logo_src);
    },
  },
};
</script>